// extracted by mini-css-extract-plugin
module.exports = {"roleSelect":"InviteCollaboratorModal_roleSelect__sjFGl"};